import { useApp } from '../../../../../context/App';
import { INews } from '../../../../../types/news';
import { parseDate } from "../../../../../utils/date";

interface Props {
	news: INews
}
export function BottomNewsMobile({ news }: Props) {
	const { configDomainURL } = useApp()
	const domain = configDomainURL

	const link_montado = news.title
		.toLowerCase()
		.replaceAll(' ', '-')
		.replaceAll('/', '-')
		.replaceAll(new RegExp('[&/\\\\#,+()$~%.\'":*?<>{}]', 'g'), '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, "")

	return (
		<a
			className="w-full flex flex-col mb-3 bg-surface-alt dark:bg-surface-dark-alt rounded-xl py-4 px-4 justify-between items-start no-underline border border-border-default dark:border-white/10 transition-colors"
			href={`${domain}noticias/${news.newsId}/${link_montado}`}
		>
			<h4 className="text-on-surface dark:text-on-surface-dark font-bold text-sm leading-tight">
				{news.title}
			</h4>
			<span className="text-on-surface-subtle dark:text-on-surface-dark-muted font-normal text-xs mt-2">
				{parseDate(news.published)}
			</span>
		</a>
	)
}